import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Youtube: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m552.99 308.21c-3.94-14.58-15.41-26.05-29.95-29.95-26.63-7.29-133.03-7.29-133.03-7.29s-106.43 0-133.03 6.98c-14.27 3.94-26.05 15.68-29.95 30.26-7.01 26.6-7.01 81.77-7.01 81.77s0 55.45 7.01 81.77c3.91 14.58 15.38 26.05 29.95 29.98 26.88 7.29 133.03 7.29 133.03 7.29s106.4 0 133.03-7.01c14.55-3.91 26.02-15.41 29.95-29.95 7.01-26.63 7.01-81.8 7.01-81.8s.28-55.45-7.01-82.05zm-196.89 132.73v-101.91l88.51 50.96-88.51 50.96z' />
    <path d='m660 660h-540v-540h465c41.35 0 75 33.64 75 75zm-210-30h180v-435c0-24.81-20.19-45-45-45h-435v480z' />
  </IconBase>
));

Youtube.displayName = 'Youtube';

export default Youtube;
